import { IHighRiskSupplementSearchDTO } from '@interfaces/highRiskSupplements';

export const createSearchPayload = (
  page: number,
  searchValue: string,
  selectedCategory?: number | string,
): IHighRiskSupplementSearchDTO => {
  const result = {
    page,
    searchValue,
  } as IHighRiskSupplementSearchDTO;
  if (selectedCategory) {
    result.selectedCategory = selectedCategory;
  }
  return result;
};
